const PRIVATE_TYPES = ['private', 'students only'];

export default PRIVATE_TYPES;